import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { PopupPage } from '../../popup/popup';
import { GN } from '../../../gn';

/**
 * Generated class for the WorkshifteditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-workshiftedit',
  templateUrl: 'workshiftedit.html',
})
export class WorkshifteditPage {
  gr: any;
  Title = ''
  startTime = '08:00'
  endTime = '16:00'
  _day = '1'
  _shift = '1'
  _orgids = []
  _orgnames = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public popoverCtrl: PopoverController, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.gr = navParams.get('gr')
    // console.log(this.gr.clientid)
    // console.log(this.gr)
    //debugger
    if (this.gr.id == -1) {
      this.Title = this.dic.l["newshift"]
      this._orgnames = this.dic.l["chooseOrgUnits"]
    } else {
      this.Title = this.dic.l["editshift"]
      this._day = this.gr.daytype
      this._shift = this.gr.shift
      this.startTime = this.gr.timefrom
      this.endTime = this.gr.timeto
      if (this.gn.clientsettings.indoor > 0) {
        //for(var o=0; o < this.gn.Organisations.length; o++) {
        if (this.gr.orgids == null || this.gr.orgids == '') {
          this._orgnames = this.dic.l["chooseOrgUnits"]
        } else {
          this._orgids = this.gr.orgids.split(',');
          for (var o = 0; o < this.gn.Organisations.length; o++) {
            for (var o1 = 0; o1 < this._orgids.length; o1++) {
              if (this._orgids[o1] == this.gn.Organisations[o].id) {
                this._orgnames += this.gn.Organisations[o].name + '; '
              }
            }
          }
        }
        //}
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WorkshifteditPage');
  }

  openTimePopup(se, _ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'timerec', selected: [], callback: function (_text, _ids) {
        if (se == 's') {
          _that.startTime = _text;
        }
        else {
          _that.endTime = _text;
        }
      }
    });
    popover.present({
      ev: _ev
    });
  }

  Save() {
    var isIndoor = 0;
    if (this.gn.clientsettings.indoor > 0) {
      isIndoor = 1;
    }

    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      shift: this.gn.crypt(this._shift),
      daytype: this.gn.crypt(this._day),
      timefrom: this.gn.crypt(this.startTime),
      timeto: this.gn.crypt(this.endTime),
      id: this.gn.crypt(this.gr.id),
      orgids: this.gn.crypt(this._orgids.toString()),
      isindoor: this.gn.crypt(isIndoor)
    }
    var _that = this
    var check = 0;

    if (isIndoor == 1) {
      for (var k = 0; k < this._orgids.length; k++) {
        var _dat1 = {
          cid: this.gn.crypt(this.gn.user.ClientId),
          shift: this.gn.crypt(this._shift),
          daytype: this.gn.crypt(this._day),
          id: this.gn.crypt(this.gr.id),
          orgid: this.gn.crypt(this._orgids[k]),
          idx: this.gn.crypt(k)
        }
        this.gn._Post('/api/gn/checkworkShift', _dat1, function (_data) {
          if (_data.msg == 'err') {
            check = 1;
          }
          //debugger
          if (_data.idx == _that._orgids.length - 1) {
            if (check == 1) {
              let toast = _that.toastCtrl.create({ message: _that.dic.l["indoorhasshift"], duration: 3000, position: 'top' });
              toast.present();
              return
            } else {
              _that.gn._Post('/api/gn/workShift', _dat, function (_data) {
                if (_data.msg == 'err') {
                  let toast = _that.toastCtrl.create({ message: _that.dic.l["hasshift"], duration: 3000, position: 'top' });
                  toast.present();
                  return
                } else {
                  var _cb = _that.navParams.get('cb')
                  if (_cb != null) {
                    _cb()
                  }
                  var _msg = _that.dic.l["succaddshift"]
                  if (_that.gr.id + '' != '-1') {
                    _msg = _that.dic.l["succedditshift"]
                  }
                  let toast = _that.toastCtrl.create({
                    message: _msg,
                    duration: 3000,
                    position: 'top'
                  });
                  toast.present();
                  _that.navCtrl.pop()
                }
              })
            }
          }
        })

      }
    } else {
      this.gn._Post('/api/gn/workShift', _dat, function (_data) {
        if (_data.msg == 'err') {
          let toast = _that.toastCtrl.create({ message: _that.dic.l["hasshift"], duration: 3000, position: 'top' });
          toast.present();
          return
        } else {
          var _cb = _that.navParams.get('cb')
          if (_cb != null) {
            _cb()
          }
          var _msg = _that.dic.l["succaddshift"]
          if (_that.gr.id + '' != '-1') {
            _msg = _that.dic.l["succedditshift"]
          }
          let toast = _that.toastCtrl.create({
            message: _msg,
            duration: 3000,
            position: 'top'
          });
          toast.present();
          _that.navCtrl.pop()
        }
      })
    }


  }

  openOrgUnits(_ev) {
    var _that = this
    let alert = this.alertCtrl.create();
    alert.setTitle(this.dic.l["organisationunits"]);

    var ch = false
    // if (this.Drivers.length == this.vehDrivers.length)
    //   ch = true;
    alert.addInput({
      type: 'checkbox',
      label: 'Сите',
      value: '0',
      checked: ch,
      handler: (data) => {
        if (data.value + '' == '0') {
          for (let i = 1; i < alert['instance']['d']['inputs'].length; i++) {
            alert['instance']['d']['inputs'][i]['checked'] = alert['instance']['d']['inputs'][0]['checked']
          }
        }
      }
    })

    //debugger
    for (var i = 0; i < this.gn.Organisations.length; i++) {
      ch = false
      for (var j = 0; j < this._orgids.length; j++) {
        if (this._orgids[j] == this.gn.Organisations[i].id) {
          ch = true
          break
        }
      }
      alert.addInput({
        type: 'checkbox',
        label: '(' + this.gn.Organisations[i].code + ') ' + this.gn.Organisations[i].name,
        value: this.gn.Organisations[i].id,
        checked: ch
      });
    }

    alert.addButton({
      text: this.dic.l["cancel"],
      handler: data => {
      }
    });
    alert.addButton({
      text: this.dic.l["ok"],
      handler: data => {
        //debugger
        _that._orgnames = ''
        _that._orgids = []
        for (var d = 0; d < data.length; d++) {
          for (var o = 0; o < _that.gn.Organisations.length; o++) {
            if (data[d] == _that.gn.Organisations[o].id) {
              _that._orgnames += _that.gn.Organisations[o].name + '; '
              _that._orgids.push(_that.gn.Organisations[o].id)
            }
          }
        }
        //debugger
        // _that.add2Drivers(data)
      }
    });
    alert.present();
  }



}



// WEBPACK FOOTER //
// ./src/pages/settings/workshift/workshiftedit.ts